import { formatAsBrIntegerNumber, formatAsBrNumber } from '~/prix'

export function formatNumberAsCluster(count: number) {
  if (count < 1000) {
    return count ? String(formatAsBrNumber(count, 2)) : String('0')
  }
  if (count < 1000000) {
    return `${formatAsBrIntegerNumber(count / 1000)}k`
  }
  return `${formatAsBrIntegerNumber(count / 1000000)}M`
}
